import React from 'react';
import { IntegrationLogsSection } from '../IntegrationLogsSection';

/**
 * Renders integration activity logs.
 *
 * @param {object} props
 * @param {string} props.companyId
 * @param {string} props.integrationId
 */
export const LogsTab = ({ companyId, integrationId }) => (
    <IntegrationLogsSection companyId={companyId} integrationId={integrationId} />
);
